import { render, staticRenderFns } from "./BalanceHtmlTemplate.vue?vue&type=template&id=06a1581c&scoped=true"
import script from "./BalanceHtmlTemplate.vue?vue&type=script&lang=js"
export * from "./BalanceHtmlTemplate.vue?vue&type=script&lang=js"
import style0 from "./BalanceHtmlTemplate.vue?vue&type=style&index=0&id=06a1581c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06a1581c",
  null
  
)

export default component.exports